// extracted by mini-css-extract-plugin
export default {"name":"columns_name__3hd13","description":"columns_description__2oZ9p","emptyState":"columns_emptyState__KsSQJ"};